exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".liveDemoComponent[data-v-f7c118c0]{padding-left:100px;width:920px}h1[data-v-f7c118c0]{font-size:14px;line-height:50px;font-weight:500;padding-bottom:30px;padding-top:60px}.liveDemo[data-v-f7c118c0]{padding-left:20px;padding-right:20px;display:block;padding-top:80px;margin-top:0;padding-bottom:80px;background-color:#fcfdff;border-top-left-radius:10px;border-top-right-radius:10px}", ""]);

// exports
